module.exports = __webpack_public_path__ + "static/media/skittle-blue.a738c2b0.png";